module.exports = __webpack_public_path__ + "img/paypal.e7cbcaa1.png";